module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Bold.5d6f50ed.otf";